// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1LUPz","loaderOuter":"PageOverlayLoader_loaderOuter__2u5R-"};